<template>
	<div>Welcome</div>
</template>

<script>
export default {
	data() {
		return {};
	},
};
</script>
